import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { WorkplaceGroupFragment } from '@api/fragments'
import { IWorkplaceGroup } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  addEmployeesToWorkplaceGroup: {
    workplaceGroup: IWorkplaceGroup
  }
}

const mutateHandler = handleFetchResult<IPayload, IWorkplaceGroup>({
  handler: (data) => data.addEmployeesToWorkplaceGroup.workplaceGroup,
  name: 'Employees',
})

const mutation = gql`
  mutation AddEmployeesToWorkplaceGroup($input: AddEmployeesToWorkplaceGroupInput!) {
    addEmployeesToWorkplaceGroup(input: $input) {
      workplaceGroup {
        ...WorkplaceGroupFragment
      }
    }
  }
  ${WorkplaceGroupFragment}
`

export default function addEmployeesToWorkplaceGroup(
  workplaceGroupId: string,
  employeeIds: string[]
): Promise<IWorkplaceGroup> {
  const input = { workplaceGroupId, employeeIds }

  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}
